import React from "react";
import AdminSelect from "./AdminSelect";
import { DEFAULT_BENEFITS, BENEFIT_ICON_OPTIONS, BenefitIcon } from "../utils/signupBenefits";

const MAX_BENEFITS = 5;

/**
 * Editor for the signup hero "benefits" (value props) — the short icon+label
 * list shown in the branded hero panel. Stored on `venue.signup_benefits` as a
 * list of { icon, label }. When the venue has none set the built-in defaults
 * are shown as the starting point; remove them all to fall back to defaults.
 *
 * Shared by the admin + client Branding editors so the two can't drift.
 *
 *   value:    venue.signup_benefits (array | null)
 *   onChange: (nextArray) => void
 */
export default function SignupBenefitsEditor({ value, onChange }) {
  const benefits = (Array.isArray(value) && value.length) ? value : DEFAULT_BENEFITS;
  const update = (i, patch) => onChange(benefits.map((b, idx) => (idx === i ? { ...b, ...patch } : b)));
  const add = () => onChange([...benefits, { icon: "check", label: "" }]);
  const remove = (i) => onChange(benefits.filter((_, idx) => idx !== i));

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
        {benefits.map((b, i) => (
          <div key={i} style={{ display: "flex", gap: "0.5rem", alignItems: "center", flexWrap: "wrap" }}>
            <span style={{ flexShrink: 0, width: 34, height: 34, borderRadius: 8, background: "var(--accent-soft)", color: "var(--accent)", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
              <BenefitIcon name={b.icon} size={18} />
            </span>
            <div className="filter-select-compact" style={{ width: 150, flexShrink: 0 }}>
              <AdminSelect value={b.icon || "check"} onChange={(v) => update(i, { icon: v })} options={BENEFIT_ICON_OPTIONS} />
            </div>
            <input className="filter-search-input" style={{ flex: 1, minWidth: 140 }} value={b.label || ""} maxLength={60} placeholder="e.g. Members-only rewards" onChange={(e) => update(i, { label: e.target.value })} />
            <button type="button" className="btn-icon" onClick={() => remove(i)} aria-label="Remove benefit">
              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
            </button>
          </div>
        ))}
      </div>
      {benefits.length < MAX_BENEFITS && (
        <button type="button" className="btn btn-outline btn-sm" style={{ marginTop: "0.75rem" }} onClick={add}>+ Add benefit</button>
      )}
      <span className="field-hint" style={{ marginTop: "0.5rem", display: "block" }}>Remove all to fall back to the built-in defaults.</span>
    </>
  );
}
